<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <slot />
      </v-col>

      <feed-card
        v-for="(article, i) in paginatedArticles"
        :key="article.title"
        :size="layout[i]"
        :value="article"
      />
    </v-row>

    <v-row align="center">
      <v-col cols="3">
        <base-btn
          aria-label="previous page button"
          v-if="page !== 1"
          class="ml-0"
          square
          title="Previous page"
          @click="page--"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </base-btn>
      </v-col>

      <v-col class="text-center subheading" cols="6">
        PAGE {{ page }} OF {{ pages }}
      </v-col>

      <v-col class="text-right" cols="3">
        <base-btn
          aria-label="Next page button"
          v-if="pages > 1 && page < pages"
          class="mr-0"
          square
          title="Next page"
          @click="page++"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </base-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Resources",

  components: {
    FeedCard: () => import("@/components/FeedCard"),
  },

  data: () => ({
    layout: [3, 3, 3, 2, 2, 3, 3, 3, 2, 2],
    page: 1,
    articles: [
      {
        title: "The Surprising Effects of Loneliness on Health",
        author: "Jane E. Brody",
        date: "Dec. 11, 2017",
        category: "Article",
        link:
          "https://www.nytimes.com/2017/12/11/well/mind/how-loneliness-affects-our-health.html",
        image:
          "https://static01.nyt.com/images/2017/12/17/science/12BRODY/12BRODY-superJumbo.jpg?quality=90&auto=webp",
      },
      {
        title: "Loneliness Can Be Deadly for Elders; Friends Are the Antidote",
        author: "Paula Span",
        date: "Dec. 30 2016",
        category: "Article",
        link:
          "https://www.nytimes.com/2016/12/30/health/loneliness-elderly.html",
        image:
          "https://static01.nyt.com/images/2017/01/03/science/03SPAN/03SPAN-superJumbo.jpg?quality=90&auto=webp",
      },
      {
        title: "Is There a Medical Cure for Loneliness?",
        author: "Lynn Darling",
        date: "December 11, 2019",
        category: "Article",
        link:
          "https://www.aarp.org/home-family/friends-family/info-2019/medical-cure-for-loneliness.html",
        image:
          "https://cdn.aarp.net/content/dam/aarp/home-and-family/family-and-friends/2019/12/1140-loneliness-crowd.imgcache.rev27227c865bac67decfbc3e417199ce64.jpg",
      },
      {
        title: "How Social Isolation Is Killing Us",
        author: "Dhruv Khullar",
        date: "Dec. 22 2016",
        category: "Article",
        link:
          "https://www.nytimes.com/2016/12/22/upshot/how-social-isolation-is-killing-us.html",
        image:
          "https://static01.nyt.com/images/2016/12/20/upshot/20up-lonely/20up-lonely-superJumbo.jpg?quality=90&auto=webp",
      },
      {
        title: "Researchers Confront an Epidemic of Loneliness",
        author: "Katie hafner",
        date: "Sep. 5 2016",
        category: "Article",
        image:
          "https://static01.nyt.com/images/2016/09/06/science/06Loneliness-Cover/06Loneliness-Cover-superJumbo-v2.jpg?quality=90&auto=webp",
        link:
          "https://www.nytimes.com/2016/09/06/health/lonliness-aging-health-effects.html",
      },
    ],
  }),

  computed: {
    pages() {
      return Math.ceil(this.articles.length / 11);
    },
    paginatedArticles() {
      const start = (this.page - 1) * 11;
      const stop = this.page * 11;

      return this.articles.slice(start, stop);
    },
  },

  watch: {
    page() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
